import Vue from 'vue'
import Router from 'vue-router'
import Home from './components/views/Home.vue'
import Order from './components/views/Order'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/order/:plan/:price',
      name: 'order',
      component: Order,
      props: true
    }
  ]
})
